import {
  ArrowBigUp,
  ArrowDown,
  ArrowLeft,
  ArrowRight,
  ArrowUp,
  Bell,
  ChevronLeft,
  CircleCheck,
  CircleUserRound,
  CloudOff,
  Command,
  Copy,
  Eye,
  EyeOff,
  House,
  Info,
  Link,
  List,
  Lock,
  LogOut,
  Mail,
  Minus,
  Monitor,
  Moon,
  Option,
  PanelLeft,
  RefreshCw,
  Sparkles,
  Sun,
  TriangleAlert,
  User,
  WifiOff,
  type LucideIcon,
} from 'lucide-react';

/**
 * The kit icons the shell draws before any screen loads: the sidebar, the account and theme
 * menus, the key caps. They ship with the first load; the rest of the kit (kit-more.tsx) loads
 * after it.
 */
export const KIT_SHELL = {
  home: House,
  me: CircleUserRound,
  user: User,
  list: List,
  link: Link,
  eye: Eye,
  'eye-off': EyeOff,
  bell: Bell,
  monitor: Monitor,
  moon: Moon,
  sun: Sun,
  spark: Sparkles,
  mail: Mail,
  refresh: RefreshCw,
  sidebar: PanelLeft,
  lock: Lock,
  'log-out': LogOut,
  'cloud-off': CloudOff,
  'circle-check': CircleCheck,
  copy: Copy,
  offline: WifiOff,
  warning: TriangleAlert,
  info: Info,
  minus: Minus,
  back: ChevronLeft,
  'arrow-up': ArrowUp,
  'arrow-down': ArrowDown,
  'arrow-left': ArrowLeft,
  'arrow-right': ArrowRight,
  /** Kbd: the Apple command, option and shift keys. */
  command: Command,
  option: Option,
  shift: ArrowBigUp,
} satisfies Record<string, LucideIcon>;
